export default __webpack_public_path__ + "static/media/covid_tracker.f19f8125.png";